/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

import { useEffect, useRef, useState } from "react";
import Footer from "../Footer/Footer";
import SettingsFieldComponent from "./SettingsFieldComponent";
import { useNavigate } from "react-router";

import { AppDispatch, RootState } from "../../../store";
import { useDispatch, useSelector } from "react-redux";
import {
  getTenantDetailsByTenantId,
  updateSettingsForTheProduct,
} from "../../../store/Tenant/tenant-actions";

import {
  IErrorProps,
  InputForSettingChangeProps,
  Tenant,
} from "../../../models";
import { tenantActions } from "../../../store/Tenant/tenant-slice";
import ErrorHandlingComponent from "../../SharedComponents/ErrorHandlingComponent";
import { serverErrorClose } from "../../SharedComponents/serverErrorClose";
import { setErrorPopupsusingErrorCode } from "../../TenantUser/setErrorPopupsusingErrorCode";
import updateErrorList from "../../../utils/methods/updateErrorList";
import Loader from "../../Loader/Loader";
import { KeyValuePair } from "tailwindcss/types/config";
import SuccessDialog from "../../SharedComponents/SuccessDialog";
import { StatusCode } from "../../../models/apiModels/Tenant";

import { getSchema } from "./validators/getSchema";
import { Card, CardContent } from "@forge/common";
import { useTranslation } from "@scuf/localization";
import { localeKeyMap } from "../../../localization/keys";
import { isEmptyField } from "./validators/isEmptyField";
interface RequestSettingProps {
  key: string;
  value: string | boolean;
  isValid: boolean;
  validation: string;
  type:
    | "secret"
    | "number"
    | "string"
    | "textbox"
    | "json"
    | "select"
    | "url"
    | "boolean"
    | "bool";
  errorMessage: string;
  rules?: any;
}

interface SettingsPageProps {
  key?: any;
  tabContent: any;
  onInputChange?: any;
  validate(): any;
  getChangedSettingsData(): any;
  productId?: any;
  updateErrorCountInTabsHandler?: any;
  tabName?: any;
  setStepperState?: any;
  // stepperState?: StepperDTO;
  stepperState?: any;

  checkIfTabHasError?: any;
  checkAllTabsForErrors?: any;
}
export const ProductSettings = (props: SettingsPageProps) => {
  const {
    tabContent,
    productId,
    updateErrorCountInTabsHandler,
    tabName,
    validate,
    setStepperState,
    stepperState,
    getChangedSettingsData,
    checkAllTabsForErrors,
  } = props;
  const metaDataSettings = useRef(tabContent?.settingsMetaData?.settings);
  const [allCallsSuccess, setAllCallsSuccess] = useState(false);
  const navigate = useNavigate();
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [t] = useTranslation();

  useEffect(() => {
    if (allCallsSuccess) {
      //  Ensure stepperState is not null or undefined before proceeding
      if (stepperState && stepperState.currentStep === "EditTenant") {
        const check = props
          ?.getChangedSettingsData()
          ?.filter(
            (x: { changedSettings: any[] }) => x.changedSettings.length > 0
          );
        if (check?.length > 0) {
          setSuccessDialogOpen(true);

          // navigate(`/tenant/user`);
        } else {
          navigate(`/tenant/user`);
        }
      }

      setStepperState({
        ...stepperState,
        currentStep: "Summary",
        steps: stepperState?.steps?.map((step: any) => {
          // Add a check to ensure step is not null or undefined
          if (step && step.id === "Settings") {
            return { ...step, status: "valid" };
          }
          return step;
        }),
      });
    }
  }, [allCallsSuccess]);

  const actualSettings = useRef(tabContent?.currentSettings?.settings);
  actualSettings.current = tabContent?.currentSettings?.settings;

  // Merge metaDataSettings with actualSettings value
  const dispatch: AppDispatch = useDispatch();
  const mergedSettings = metaDataSettings?.current?.map(
    (metaDataSetting: any) => {
      const matchingActualSetting = actualSettings?.current?.find(
        (setting: any) => setting.key === metaDataSetting.key
      );

      if (matchingActualSetting) {
        return {
          ...metaDataSetting,
          errorMessage: matchingActualSetting?.errorMessage,
          value: matchingActualSetting.value,
        };
      } else {
        return {
          ...metaDataSetting,
          value: metaDataSetting.defaultValue,
        };
      }
    }
  );
  const tenantDetails: Tenant = useSelector(
    (state: RootState) => state?.cart?.tenantDeatailsByTenantId
  );
  const [newSettings, setNewSettings] = useState<RequestSettingProps[]>(
    mergedSettings?.map((x: RequestSettingProps) => ({
      key: x?.key,
      value: x?.value,
      //isValid: x?.isValid ?? true,
      validation: x?.validation,
      errorMessage: x?.errorMessage ?? "",
    }))
  );

  ///////////////Error Handling////////////////////////
  const [isLoading, setIsLoading] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal,
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };

  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError,
    });
  }, [errorListGlobal]);

  //////////////Error Handling////////////////////////

  useEffect(() => {
    // 1.1 need to add errorMessage rightly here
    const updatedSettings = mergedSettings?.map((x: RequestSettingProps) => {
      const isValid = x?.errorMessage === undefined || x?.errorMessage === "";
      return {
        key: x?.key,
        value: x?.value,
        errorMessage: x?.errorMessage ?? "",
        rules: x?.rules ?? [],
      };
    });

    // Check if the new settings are different from the current settings
    if (JSON.stringify(newSettings) !== JSON.stringify(updatedSettings)) {
      setNewSettings(updatedSettings);
    }
  }, [mergedSettings]);

  /// Get error count

  useEffect(() => {
    const errorCount = newSettings?.filter(
      (x) => x?.errorMessage?.length > 0
    )?.length;
    if (errorCount !== undefined && errorCount !== null) {
      updateErrorCountInTabsHandler(errorCount, tabName);
    }
  }, [newSettings]);
  const onInputChange = (
    event: any,
    setting: any,
    productId: string,
    errorMessage?: string
  ) => {
    const inputValueWithItsMetaData: InputForSettingChangeProps = {
      event,
      setting,
      productId,
      errorMessage,
    };

    props.onInputChange(inputValueWithItsMetaData);
  };

  // Handle back button for footer
  //istanbul ignore next
  //this function specfic product settings
  const onBackBtn = () => {
    if (stepperState?.currentStep === "EditTenant") {
      navigate(`/tenant/user`);
    }

    setIsLoading(true);

    dispatch(getTenantDetailsByTenantId({ tenantId: tenantDetails?.tenantId }))
      .unwrap()
      .then()
      .catch((error) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
    //#TODO - here if any error check any old branch 2410 - #154

    setStepperState({
      ...stepperState,
      currentStep: "EditTenantBack",
      steps: stepperState?.steps?.map((step: any) => {
        if (step.id === "Settings") {
          return { ...step, status: undefined };
        }
        return step;
      }),
    });
  };

  // Handle Submit for product settings
  // istanbul ignore next
  // Check validity of the form
  function handleSumbit() {
    // Check for empty fields and update error messages
    const updatedNewSettings = newSettings.map((setting) => {
      const metadataSetting = metaDataSettings.current?.find(
        (metadata: any) => metadata.key === setting.key
      );
      if (metadataSetting?.required === true && isEmptyField(setting.value)) {
        return {
          ...setting,
          errorMessage: t(localeKeyMap.requiredField)
        };
      }
      return setting;
    });
    
    // Update the newSettings state with error messages for empty fields
    setNewSettings(updatedNewSettings);
    
    //Step1-> Calculate error count of tabs
    // 1.1 -> Get all tabs names and their error count
    // 1.2 Do a map and dispatch the results to update the error count in tabs
    // 1.3 If isTabsValid is true then proceed with the below code else return

    // props.tabContent=tabContent;
    const TabAndErrorsOnNext: KeyValuePair<string, number>[] =
      props?.checkAllTabsForErrors();

    //const isInvalidTabs = TabAndErrorsOnNext.some((x) => x.value > 0);
    const isTabsValid = !TabAndErrorsOnNext.some((x) => x.value > 0);
    if (!isTabsValid) return;
    // Get form data to be dispatched
    const settingsDataToBeDispatched = props
      ?.getChangedSettingsData()
      ?.filter(
        (x: { changedSettings: any[] }) => x.changedSettings?.length > 0
      );

    // If all form data responds with success, then do the below else throw exception
    // Dispatch the action to update the settings
    let APIresponsesMappingWthProduct = settingsDataToBeDispatched?.map(
      (setting: any) => {
        return {
          productId: setting?.productId,
          isAPIRepsonseSuccess: false,
        };
      }
    );
    if (settingsDataToBeDispatched?.length === 0) {
      setAllCallsSuccess(true);
    } else {
      settingsDataToBeDispatched?.forEach((setting: any) => {
        setIsLoading(true);
        const settingAndTenant = {
          setting: setting,
          tenantId: tenantDetails?.tenantId,
        };
        dispatch(updateSettingsForTheProduct(settingAndTenant))
          .unwrap()
          .then((response: any) => {
            // Handle the response

            APIresponsesMappingWthProduct = APIresponsesMappingWthProduct.map(
              (x: any) => {
                if (x.productId === setting.productId) {
                  return { ...x, isAPIRepsonseSuccess: true };
                }
                return x;
              }
            );
            if (
              APIresponsesMappingWthProduct?.every(
                (x: any) => x.isAPIRepsonseSuccess
              )
            ) {
              dispatch(tenantActions.resetSettingsError());
              setAllCallsSuccess(true);
            }
          })
          .catch((error: any) => {
            setErrorListGlobal((prevState) =>
              updateErrorList(error, [...prevState])
            );

            // Handle the error
            APIresponsesMappingWthProduct = APIresponsesMappingWthProduct.map(
              (x: any) => {
                if (x.productId === setting.productId) {
                  return { ...x, isAPIRepsonseSuccess: false };
                }
                return x;
              }
            );
            // Update the error count in Tab which threw error
            dispatch(
              tenantActions.updateSettingsNetworkError({
                tabName: setting.productId,
              })
            );
          })
          .finally(() => {
            setIsLoading(false);
          });
      });
    }

    if (
      APIresponsesMappingWthProduct?.every((x: any) => x.isAPIRepsonseSuccess)
    ) {
      if (stepperState?.currentStep === "EditTenant") {
        const check = props
          ?.getChangedSettingsData()
          ?.filter(
            (x: { changedSettings: any[] }) => x?.changedSettings?.length > 0
          );
        if (check?.length > 0) {
          setSuccessDialogOpen(true);
          // navigate(`/tenant/user`);
        } else {
          navigate(`/tenant/user`);
        }
      } else {
        setStepperState({
          ...stepperState,
          currentStep: "Summary",
          steps: stepperState?.steps?.map((step: any) => {
            // CID 3334115 , 3403118
            if (step !== null && step !== undefined) {
              if (step.id === "Settings") {
                return { ...step, status: "valid" };
              } else if (
                step?.id === "CreateTenant" ||
                step?.id === "EditTenant"
              ) {
                return { ...step, status: "valid" };
              }
              return { ...step };
            }
          }),
        });
      }
    }
  }

  return (
    <>
      <Card className="mx-auto mt-6 w-[70vw] min-w-full max-w-4xl border-box-shadow-none">
        <CardContent className="card-content-product-settings">
          {mergedSettings?.map((setting: any) => {
            return (
              <SettingsFieldComponent
                setting={setting}
                newSettings={newSettings}
                onInputChange={onInputChange}
                productId={productId}
                TryThisSchema={getSchema(setting)}
              />
            );
          })}
        </CardContent>
      </Card>
      <Footer
        // cancelButtonRequired={location.pathname.includes("edit") ? true : false}
        cancelButtonRequired={true}
        //TODO : disable back button in edit
        openDialogCreate={false}
        setOpenDialogCreate={() => {}}
        openDialogonClose={false}
        openDialogCancel={false}
        onBackBtn={onBackBtn}
        setOpenDialogCancel={function (value: boolean): void {}}
        createBtnLabel={t(localeKeyMap.next)}
        cancelBtnLabel={t(localeKeyMap.back)}
        checkIfAnyTextFilled={() => {}}
        onSubmit={handleSumbit}
        validate={() => {
          handleSumbit();
        }}
        // IsNextDisabled={!props?.checkIfTabHasError}
      />

      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal.concat(toastErrors.current)}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={false}
        onCloseServerConflictError={function (): void {}}
      />
      {isLoading && <Loader />}
      {successDialogOpen &&
        (tenantDetails?.status == StatusCode.SetupCompleted ||
          tenantDetails?.status == StatusCode.TenantUpdated) && (
          <SuccessDialog
            open={successDialogOpen}
            title={t(localeKeyMap.tenantUpdated)}
            successMessage={
              <div>
                {t(localeKeyMap.navigateToTenantPageClick)}{' '}
                <strong>{t(localeKeyMap.publish)}</strong>{' '}
                {t(localeKeyMap.toActivateTheChanges)}
              </div>
            }
            handleClose={() => {
              navigate("/tenant/user");
            }}
          />
        )}
    </>
  );
};